import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// login
import LoginReducer from "./auth/login/reducer";

// register
import RegisterReducer from "./auth/register/reducer";

// userProfile
import ProfileReducer from "./auth/profile/reducer";

// projects
import ProjectReducer from "./projects/reducer";

// Ecommerce
import EcommerceReducer from "./ecommerce/reducer";

// Booking
import BookingReducer from "./booking/reducer";

// Reward
import RewardReducer from "./rewards/reducer";

// maintenances
import MaintenancesReducer from "./maintenances/reducer";

// Users
import UsersReducer from "./users/reducer";

// Customers
import CustomersReducer from "./customers/reducer";

// Notifications
import NotificationsReducer from "./notifications/reducer";

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  Register: RegisterReducer,
  Profile: ProfileReducer,
  Users: UsersReducer,
  Projects: ProjectReducer,
  Ecommerce: EcommerceReducer,
  Booking: BookingReducer,
  Reward: RewardReducer,
  Maintenances: MaintenancesReducer,
  Customers: CustomersReducer,
  Notifications: NotificationsReducer,
});


export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;